<div class="flex flex-col">

  <!-- Header -->
  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Despesas dos Clientes</h1>
        <p class="text-sm text-gray-500">Gerencie as despesas de seus clientes</p>
      </div>
      <button (click)="createExpense()" class="bg-orange-500 hover:bg-orange-600 cursor-pointer text-white px-4 py-2 rounded">
        Nova Despesa
      </button>
    </div>
  </div>

  <!-- Filtros -->
  <div class="px-6 py-4 bg-white shadow shrink-0 z-10">
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4">

      <!-- Input de busca -->
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Buscar Cliente</label>
        <input
          pInputText
          type="text"
          [(ngModel)]="searchTerm"
          (input)="onSearchChange()"
          placeholder="Digite o nome do cliente..."
          class="w-full text-sm"
        />
      </div>

      <!-- Dropdown de status -->
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Status</label>
        <p-dropdown
          [options]="statusOptions"
          [(ngModel)]="currentStatus"
          (onChange)="onStatusChange()"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o status"
          class="w-full text-sm"
        ></p-dropdown>
      </div>

      <!-- Dropdown de período -->
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Período</label>
        <p-dropdown
          [options]="dateRangeOptions"
          [(ngModel)]="currentDateRange"
          (onChange)="onDateRangeChange()"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o período"
          class="w-full text-sm"
        ></p-dropdown>
      </div>

      <!-- Dropdown de Tipo de Cliente -->
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Tipo de Cliente</label>
        <p-dropdown
          [options]="customerTypeOptions"
          [(ngModel)]="currentCustomerType"
          (onChange)="onCustomerTypeChange()"
          optionLabel="label"
          optionValue="value"
          placeholder="Todos"
          class="w-full text-sm"
        ></p-dropdown>
      </div>
      
    </div>
  </div>


<!-- Cards resumo -->
<div class="px-6 py-4 grid grid-cols-1 lg:grid-cols-6 gap-4">

  <!-- Coluna dos Charts (2 cards grandes) -->
  <div class="lg:col-span-4" [ngClass]="currentStatus === 'todos' ? 'grid grid-cols-2 gap-4' : 'grid grid-cols-1 gap-4'">
    
    <!-- A pagar -->
    <p-card *ngIf="currentStatus === 'pendente' || currentStatus === 'todos'" header="A pagar">
      <div class="h-full" style="height: 165px;">
        <div class="flex flex-col justify-center h-1/3">
          <div class="text-3xl font-bold text-gray-800">
            R$ {{ financialDashboard.totalValuePending| number:'1.2-2' }}
          </div>
        </div>
        <div class="flex justify-end items-end h-2/3">
          <div [ngClass]="currentStatus === 'todos' ? 'w-32 xl:w-64' : 'w-80 xl:w-150'">
            <p-chart
              type="bar"
              [data]="getTotalValuePendingChartData()"
              [options]="barChartOptions">
            </p-chart>
          </div>
        </div>
      </div>
    </p-card>

    <!-- Total gasto -->
    <p-card *ngIf="currentStatus === 'todos'" header="Total gasto"> 
    
      <div class="h-full" style="height: 165px;">
        <div class="flex flex-col justify-center h-1/3">
          <div class="text-3xl font-bold text-gray-800">
            R$ {{ financialDashboard.totalValueExpenses | number:'1.2-2' }}
          </div>
        </div>
        <div class="flex justify-end items-end h-2/3">
          <div class="w-32 xl:w-64">
            <p-chart
              type="bar"
              [data]="getTotalValueExpensesChartData()"
              [options]="barChartOptions">
            </p-chart>
          </div>
        </div>
      </div>
    </p-card>

    <p-card *ngIf="currentStatus === 'quitado'" header="Total quitado"> 
    
      <div class="h-full" style="height: 165px;">
        <div class="flex flex-col justify-center h-1/3">
          <div class="text-3xl font-bold text-gray-800">
            R$ {{ financialDashboard.totalValuePaid| number:'1.2-2' }}
          </div>
        </div>
        <div class="flex justify-end items-end h-2/3">
          <div class="w-80 xl:w-150">
            <p-chart
              type="bar"
              [data]="getTotalValuePaidChartData()"
              [options]="barChartOptions">
            </p-chart>
          </div>
        </div>
      </div>
    </p-card>

    <p-card *ngIf="currentStatus === 'cancelado'" header="Total cancelado"> 
    
      <div class="h-full" style="height: 165px;">
        <div class="flex flex-col justify-center h-1/3">
          <div class="text-3xl font-bold text-gray-800">
            R$ {{ financialDashboard.totalValueCanceled| number:'1.2-2' }}
          </div>
        </div>
        <div class="flex justify-end items-end h-2/3">
          <div class="w-80 xl:w-150">
            <p-chart
              type="bar"
              [data]="getTotalValueCanceledChartData()"
              [options]="barChartOptions">
            </p-chart>
          </div>
        </div>
      </div>
    </p-card>
  </div>

  <!-- Grid 2x2 de Cards Pequenos -->
  <div class="lg:col-span-2 grid grid-cols-2 gap-4 gap-y-4">
    
    <!-- Despesas -->
    <p-card header="Despesas" class="h-full">
      <div class="flex flex-col justify-center h-full">
        <div class="text-3xl font-bold text-gray-800">
          {{ financialDashboard.totalExpenses| number }}
        </div>
      </div>
    </p-card>

    <!-- Clientes -->
    <p-card header="Clientes" class="h-full">
      <div class="flex flex-col justify-center">
        <div class="text-3xl font-bold text-gray-800">
          {{ financialDashboard.activeSuppliers + financialDashboard.activeEmployees + financialDashboard.activeCompanies }}
        </div>
      </div>
    </p-card>

    <!-- Despesas Pendentes - só mostra quando currentStatus = 'todos' -->
    <p-card *ngIf="currentStatus === 'todos'" header="Pendentes" class="h-full">
      <div class="flex flex-col justify-center h-full">
        <div class="text-3xl font-bold text-yellow-600">
          {{ financialDashboard.pendingExpenses }}
        </div>
      </div>
    </p-card>

    <!-- Despesas Quitadas - só mostra quando currentStatus = 'todos' -->
    <p-card *ngIf="currentStatus === 'todos'" header="Quitadas" class="h-full">
      <div class="flex flex-col justify-center h-full">
        <div class="text-3xl font-bold text-green-600">
          {{ financialDashboard.paidExpenses }}
        </div>
      </div>
    </p-card>
  </div>

</div>

  <!-- Tabela -->
  <div class="flex-1 overflow-y-auto px-6 py-4 bg-gray-50">
    <div class="bg-white shadow rounded overflow-x-auto">
      <p-table 
        [value]="financials" 
        [paginator]="false"
        [loading]="loading"
        styleClass="p-datatable-sm"
        [rowHover]="true"
        [stripedRows]="true"
        stripedRowsClass="bg-orange-50"
        [showCurrentPageReport]="false"
        responsiveLayout="scroll"
        class="min-w-full text-sm">
        <ng-template pTemplate="header">
          <tr class="bg-gray-100">
            <th class="text-left px-6 py-3">Código</th>
            <th class="text-left px-6 py-3">Nome</th>
            <th class="text-left px-6 py-3">Total (R$)</th>
            <th class="text-left px-6 py-3">Situação</th>
            <th class="text-left px-6 py-3">Despesas</th>
            <th class="text-left px-6 py-3">Ações</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customer let-i="rowIndex">
          <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
            <td class="px-6 py-2 font-mono">{{ getCustomerId(customer) }}</td>
            <td class="px-6 py-2 font-semibold text-gray-900">{{ getCustomerName(customer) }}</td>
            <td class="px-6 py-2">R$ {{ getTotalExpense(customer) | number:'1.2-2' }}</td>
            <td class="px-6 py-2">
              <p-tag
                [value]="customer.status"
                [severity]="getStatusSeverity(customer.status)"
                [rounded]="false">
              </p-tag>
            </td>
            <td class="px-6 py-2">{{ getExpenseCount(customer) }}</td>
            <td class="px-6 py-2">
              <div class="flex space-x-2">
                <p-button
                  pTooltip="Ver Despesas"
                  icon="pi pi-pencil"
                  text
                  severity="secondary"
                  (click)="goToExpenses(customer)">
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center py-8 text-gray-500">
              Nenhum cliente encontrado
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    
    <!-- Paginator -->
    <div class="flex justify-center py-4">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        (onPageChange)="onPageChange($event)"
        [showCurrentPageReport]="true"
        [showPageLinks]="true"
        [showFirstLastIcon]="true"
        styleClass="custom-paginator">
      </p-paginator>
    </div>
  </div>

</div>
